import { jsx as _jsx, jsxs as _jsxs } from "theme-ui/jsx-runtime";
import { Fragment } from "react";
import { Box, Flex } from "theme-ui";
import { HeadingRegularVariants, ParagraphSizeEnum, TechnicalParagraph, Colors, Fonts, FontWeight, TextVariants } from "../../index";
// renders a paragraph with a header, used primarily on FAQ type pages
export const TextLockupSectionParagraph = ({ title, content }) => {
    return (_jsxs(Flex, { sx: { flexDirection: ["column", "column", "row"] }, children: [_jsx(Box, { sx: { mr: [null, null, 45], mb: [8, 8, null] }, children: _jsx("h6", { sx: {
                        variant: `text.${HeadingRegularVariants.sixth}`,
                        color: "grey.0"
                    }, children: title }) }), _jsx(Box, { sx: { maxWidth: [327, 327, 492] }, children: _jsx("p", { sx: {
                        color: `${Colors.grey}.0`,
                        variant: `text.${TextVariants.editorialParagraphLarge}}`
                    }, children: content }) })] }));
};
/*
  Renders a text lockup comprised of a sentence introint the links, followed by optional label and links
*/
// TODO : add internal theme mode for when its on a dark or light background
export const SentenceAndLinks = ({ sentence, label, children }) => {
    return (_jsxs(Fragment, { children: [sentence && sentence.length > 0 && (_jsx(Box, { sx: { mt: 8, mb: [16, null, null, 32] }, children: _jsx("p", { className: "color-mode-title", sx: {
                        maxWidth: "34ch",
                        variant: TextVariants.editorialParagraphLarge
                    }, children: sentence }) })), _jsxs(Flex, { sx: { flexFlow: "row wrap" }, children: [label && (_jsx(Box, { sx: { mb: 4, mr: 8 }, children: _jsx("p", { sx: {
                                variant: TextVariants.editorialParagraphLarge,
                                opacity: 0.7
                            }, className: "color-mode-title", children: label }) })), _jsx(Flex, { className: "color-mode-title", sx: {
                            flexFlow: "row wrap",
                            "& > *": {
                                mr: [8, 12, 8],
                                pt: [0, null, 0]
                            }
                        }, children: children && children })] })] }));
};
export const CategoryCardText = ({ section, title, message, children }) => {
    return (_jsxs(Flex, { sx: {
            flexDirection: "column",
            pr: 24,
            flexGrow: 1
        }, children: [_jsxs(Flex, { sx: {
                    flexFlow: "row wrap",
                    maxWidth: ["100%", "100%", "100%", "60%"]
                }, children: [section && (_jsx(Box, { sx: {
                            mr: 4,
                            fontFamily: Fonts.display,
                            fontSize: "scale0",
                            fontWeight: FontWeight.displayRegular
                        }, children: section })), _jsx(Box, { className: "color-mode-title", sx: {
                            fontFamily: Fonts.display,
                            fontSize: "scale0",
                            fontWeight: FontWeight.displayRegular
                        }, children: title })] }), _jsx(Box, { sx: {
                    mb: 24,
                    mt: 0,
                    maxWidth: "40ch"
                }, children: _jsx(TechnicalParagraph, { variant: ParagraphSizeEnum.large, children: message }) }), children && (_jsx(Flex, { sx: {
                    flexFlow: "row wrap",
                    mt: "auto",
                    "& > *": {
                        mr: 16
                    }
                }, children: children }))] }));
};
//# sourceMappingURL=TextLockUps.js.map